import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as ROUTES from "src/constants/routes";

interface AuthContextType {
  isAuthenticated: boolean;
  token: string | null;
  login: (token: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  token: null,
  login: () => { },
  logout: () => { },
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string | null>(() => localStorage.getItem("uniservice_token"));

  const login = (newToken: string) => {
    localStorage.setItem("uniservice_token", newToken);
    setToken(newToken);
    navigate(ROUTES.DASHBOARD);
  };

  const logout = () => {
    localStorage.removeItem("uniservice_token");
    setToken(null);
    navigate(ROUTES.LOGIN);
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const storedToken = localStorage.getItem("uniservice_token");
      setToken(storedToken);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated: !!token, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
